// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang'
import axios from 'axios'
import Qs from 'qs'

import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2' //复制
import VueQriously from 'vue-qriously'
import * as filters from './utils/filters.js'
import sha1 from 'js-sha1'
import * as socketApi from "./utils/ws_service.js";

Vue.use(VueQriously)
Vue.prototype.$sha1 = sha1;
import Trend from "vuetrend"
Vue.use(Trend)

import 'wowjs/css/libs/animate.css'
import wowjs from './utils/wow.js'
Vue.prototype.$wow = wowjs;

import './utils/flexible.js'

import '@/permission'

Vue.use(Toast,{
  type: 'center',
  duration: 3000,
  wordWrap: true,
})

Vue.use(ElementUI)
Vue.use(i18n)
Vue.use(VueClipboard)
Vue.config.productionTip = false

//全局ws
Vue.prototype.$ws = socketApi;
socketApi.connect()

Vue.prototype.hkdz = window.GLOBAL.hkdz;

document.title = window.GLOBAL.TITLE[store.state.lang]

Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

Vue.directive('on-paste', {
  bind(el, binding, vnode) {
    el.addEventListener('paste', (event) => {
      // 阻止默认行为
      event.preventDefault();

      // 获取剪切板中的数据
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');

      // 处理粘贴的数据，如果是验证码，应该是完整的字符串
      if (binding.value && typeof binding.value === 'function') {
        binding.value(pastedData);
      }
    });
  }
});

// pc-LDcoin
axios.defaults.timeout = 30000 // 请求超时

// axios.defaults.baseURL = 'http://47.83.198.156:8100'  // api 即上面 vue.config.js 中配置的地址
// Vue.prototype.domain = 'http://47.83.198.156:8100';
axios.defaults.baseURL = window.GLOBAL.HOSTLD;  // api 即上面 vue.config.js 中配置的地址
Vue.prototype.domain = window.GLOBAL.HOSTLD;
Vue.prototype.project = window.GLOBAL.downLoad;
Vue.prototype.HOSTK = window.GLOBAL.HOSTK;
Vue.prototype.HOST2 = window.GLOBAL.HOST2;
Vue.prototype.HOSTMn = window.GLOBAL.HOSTMn;

Vue.prototype.socket_url = window.GLOBAL.webSocket;
Vue.prototype.webSocketAll = window.GLOBAL.webSocketAll;

axios.defaults.transformRequest = [data => {
  return Qs.stringify(data)
}]
axios.interceptors.request.use(function(config){
  store.state.isLoad = false; //在请求发出之前进行一些操作
  config.params = {
    lang: localStorage.getItem('lang') || 'en',
    ...config.params
  }
  return config
})

//定义一个响应拦截器
axios.interceptors.response.use((config) =>{
  store.state.isLoad = false;//在这里对返回的数据进行处理
  return config
},(err) =>{
  return Promise.reject(err)
})

Vue.prototype.$ajax = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
  store
})



// WEBPACK FOOTER //
// ./src/main.js